var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
import { Observable } from 'rxjs/Rx';
import { InterruptArgs } from './interruptargs';
import { InterruptSource } from './interruptsource';
/*
 * An interrupt source on an EventTarget object, such as a Window or HTMLElement.
 */
export var EventTargetInterruptSource = (function (_super) {
    __extends(EventTargetInterruptSource, _super);
    function EventTargetInterruptSource(target, events, throttleDelay) {
        var _this = this;
        if (throttleDelay === void 0) { throttleDelay = 500; }
        _super.call(this, null, null);
        this.target = target;
        this.events = events;
        this.throttleDelay = throttleDelay;
        this.eventSrc = new Array;
        this.eventSubscription = new Array;
        var self = this;
        events.split(' ').forEach(function (event) {
            var src = Observable.fromEvent(target, event);
            if (self.throttleDelay > 0) {
                src = src.throttleTime(self.throttleDelay);
            }
            self.eventSrc.push(src);
        });
        var handler = function (innerArgs) {
            if (self.filterEvent(innerArgs)) {
                return;
            }
            var args = new InterruptArgs(this, innerArgs);
            self.onInterrupt.emit(args);
        };
        this.attachFn = function () {
            _this.eventSrc.forEach(function (src) {
                self.eventSubscription.push(src.subscribe(handler));
            });
        };
        this.detachFn = function () {
            _this.eventSubscription.forEach(function (sub) {
                sub.unsubscribe();
            });
            _this.eventSubscription.length = 0;
        };
    }
    /*
     * Checks to see if the event should be filtered. Always returns false unless overriden.
     * @param event - The original event object.
     * @return True if the event should be filtered (don't cause an interrupt); otherwise, false.
     */
    EventTargetInterruptSource.prototype.filterEvent = function (event) {
        return false;
    };
    return EventTargetInterruptSource;
}(InterruptSource));
//# sourceMappingURL=eventtargetinterruptsource.js.map


//////////////////
// WEBPACK FOOTER
// /home/backend/KreditCentr/WebLombard/client/~/@ng-idle/core/src/eventtargetinterruptsource.js
// module id = ../../../../@ng-idle/core/src/eventtargetinterruptsource.js
// module chunks = 3